import { gql } from 'apollo-boost';

export default gql`
  mutation UpdateNews($id: Int!, $set: news_set_input) {
    update_news(where: { id: { _eq: $id } }, _set: $set) {
      affected_rows
    }
  }
`;
